// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__2vBnx","title":"Section_title__23FVv"};